import 'phaser'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { common } from '../main/common-sidecar'
import { fi32 } from '../main/frameInfo'
import { layers } from '../main/layers-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { ITileMapShip } from '../tiles/tileMapShip'

export interface IPathHighlight extends IEntity {
  image: Phaser.GameObjects.Image
}

const objs: IPathHighlight[] = []

export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

let frames = [fi32(1, 6, 7), fi32(1, 6, 8)]

export function create(): IPathHighlight {
  let id = common.createId()

  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().highlights,
    frames[0],
    0,
    0,
  )
  image.alpha = 0.75

  let obj: IPathHighlight = {
    eType: 'path-highlight',
    id,
    image,
    isDead: false,
  }
  objs.push(obj)
  return obj
}

export function moveToTile(
  obj: IPathHighlight,
  map: ITileMapShip,
  x: number,
  y: number,
) {
  obj.image.x = map.ox + x * map.tileSize
  obj.image.y = map.oy + y * map.tileSize
}

export function setRotation(
  obj: IPathHighlight,
  a: { x: number; y: number },
  b?: { x: number; y: number },
) {
  if (!b) {
    obj.image.rotation = 0
    spriteMap.setFrame(obj.image, frames[1])
    return
  }
  spriteMap.setFrame(obj.image, frames[0])
  let turn = Math.PI * 2
  if (b.x > a.x) {
    obj.image.rotation = turn * 0
  }
  if (b.y > a.y) {
    obj.image.rotation = turn * 0.25
  }
  if (b.y < a.y) {
    obj.image.rotation = turn * 0.75
  }
  if (b.x < a.x) {
    obj.image.rotation = turn * 0.5
  }
}

export function setVisible(obj: IPathHighlight, visible: boolean) {
  obj.image.visible = visible
}

export function kill(obj: IPathHighlight) {
  obj.isDead = true
  obj.image.tint = 0xccc
}

export function updateAll() {
  objs.forEach((c) => {
    // update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
  })
}
